import script from "./kyzs.vue?vue&type=script&setup=true&lang=js"
export * from "./kyzs.vue?vue&type=script&setup=true&lang=js"

import "./kyzs.vue?vue&type=style&index=0&id=4063c2fa&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4063c2fa"]])

export default __exports__